var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',{staticClass:"px-1 px-md-10"},[_c('v-fade-transition',{attrs:{"mode":"out-in","duration":"200"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }